import React from 'react';
import { Show, SimpleShowLayout, EditButton, RichTextField, ReferenceField, ReferenceManyField, Pagination, Datagrid, TextField, useRefresh, usePermissions, DeleteButton } from 'react-admin';
import CustomDateField from '../components/CustomDateField';
import CustomDefaultShowComponent from '../components/CustomDefaultShowComponent';
import CustomInspectedFrequenciesField from '../components/CustomInspectedFrequenciesField';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import ContactIcon from '@material-ui/icons/PermPhoneMsg';
import InspectionsIcon from '@material-ui/icons/FindReplace';

const InspectorShowActions = (props) => {
    const { basePath } = props;

    return (
        <CardActions>
            <BackButton style={{ marginRight: "auto" }}></BackButton>
            <EditButton basePath={basePath} record={props.data} />
        </CardActions>
    );
};

const InspectorShowGeneral = ({ record }) => {
    const { active, display_name } = record;

    return (
        <div className="row">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row row-cols-2 row-cols-lg-2 g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Name </h6>
                        {display_name ? display_name.length > 0 ? <span className="fw-italic m-0 p-0">{display_name}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Active</h6>
                        {active ? <span className={(active) ? 'text-success' : 'text-danger'}>{(active) ? <CheckIcon /> : <ClearIcon />}</span> : CustomDefaultShowComponent}
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 mb-3 m-o p-0">
                <InspectorShowNotes record={record} />
            </div>
        </div>
    );
};

const InspectorShowNotes = ({ record }) => {
    const { notes } = record;

    return (
        <div className="row h-100 w-100 m-0 p-0">
            <div>
                <h6 className="text-secondary" style={{ marginBottom: '10px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Notes</h6>
                <div className="p-2 pb-0 w-100 h-100" style={{ backgroundColor: 'rgb(255, 238, 201)', borderRadius: '0px 5px 5px 5px' }}>
                    {notes ? notes.length > 0 ? <RichTextField source="notes" style={{ fontSize: '1em' }} /> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                </div>
            </div>
        </div>
    );
};

const InspectorShowContact = ({ record }) => {
    const { email, phone } = record;

    return (
        <div className="d-flex justify-content-center w-50 g-2 g-lg-2 mb-2 row">
            <div className="col">
                <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Phone</h6>
                {phone ? phone.length > 0 ? <span className="fw-italic text-lowercase">{phone}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
            <div className="col">
                <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Email</h6>
                {email ? email.length > 0 ? <span className="fw-italic text-lowercase">{email}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
        </div>
    );
};

const InspectionSectionTitle = ({ record }) => {
    return (
        <div className="d-flex align-items-center" >
            <h5 className="font-weight-normal pt-2">{<InspectionsIcon className="d-inline text-danger" style={{ fontSize: '38px' }} />} Inspections </h5>
        </div>
    )
}

const InspectorShow = (props) => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    let inspectionDeleteButton = null;
    if (isAdmin) { inspectionDeleteButton = ( <DeleteButton redirect={toRedirect} /> ) }
    
    return(
    <>
        <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Inspector</h3>
        <Show title=" " actions={<InspectorShowActions />} {...props}>
            <SimpleShowLayout>
                <InspectorShowGeneral className="mb-3" record={{ ...props }} />

                <h6 className="font-weight-normal pt-2">{<ContactIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Contact</h6>
                <InspectorShowContact className="mb-3" record={{ ...props }} />

                <InspectionSectionTitle record={{ ...props }} />

                <ReferenceManyField
                    addLabel={false}
                    reference="inspections"
                    target="inspector_id"
                    source="inspector_id"
                    sort={{ field: 'date', order: 'DESC' }}
                    display="flex" flex="0 0 100%" flexWrap="wrap"
                    pagination={<Pagination />}
                    perPage={10}
                    emptyText="Nothing to show"
                >
                    <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                        <CustomDateField source="date" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Date </h6>} />
                        <ReferenceField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>System Name </h6>} source="system_id" resource="systems" reference="systems" link="show">
                            <TextField className="text-capitalize" source="name" />
                        </ReferenceField>
                        <ReferenceField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Inspector </h6>} source="inspector_id" resource="inspectors" reference="inspectors" link="show">
                            <TextField className="text-capitalize" source="display_name" />
                        </ReferenceField>
                        <CustomInspectedFrequenciesField className="text-capitalize" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Inspected </h6>} source="inspected" />
                        {inspectionDeleteButton}
                    </Datagrid>
                </ReferenceManyField>
            </SimpleShowLayout>
        </Show>
    </>
)};

export default InspectorShow;
